var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.92871C14.2164 1.92871 16.3421 2.80919 17.9094 4.37646C19.4766 5.94373 20.3571 8.0694 20.3571 10.2859C20.3571 13.8173 17.8757 17.6659 12.9771 21.8727C12.7047 22.1067 12.3574 22.2352 11.9984 22.2349C11.6393 22.2346 11.2922 22.1055 11.0203 21.871L10.6963 21.5899C6.01454 17.4927 3.64282 13.7384 3.64282 10.2859C3.64282 8.0694 4.5233 5.94373 6.09057 4.37646C7.65784 2.80919 9.78351 1.92871 12 1.92871ZM12 7.07157C11.1475 7.07157 10.3299 7.41021 9.72712 8.01301C9.12433 8.61581 8.78568 9.43337 8.78568 10.2859C8.78568 11.1383 9.12433 11.9559 9.72712 12.5587C10.3299 13.1615 11.1475 13.5001 12 13.5001C12.8524 13.5001 13.67 13.1615 14.2728 12.5587C14.8756 11.9559 15.2143 11.1383 15.2143 10.2859C15.2143 9.43337 14.8756 8.61581 14.2728 8.01301C13.67 7.41021 12.8524 7.07157 12 7.07157Z",
    fill: "#CB2129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDark);
export default __webpack_public_path__ + "static/media/location-dark.ee50ed836e3478f4a5c40ade4c270377.svg";
export { ForwardRef as ReactComponent };